/* eslint-disable consistent-return */
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";

import { styled } from "@material-ui/core/styles";
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Menu,
  Divider,
} from "@material-ui/core";
import xLg from "@iconify/icons-bi/x-lg";
import LogoAcc from "components/LogoAcc";
import { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "redux/store";
import { isMobile } from "react-device-detect";
import logo from "../../../assets/ic_logo.svg";
import useCollapseDrawer from "../../../hooks/useCollapseDrawer";
// components
import { MHidden } from "../../../components/@material-extend";
import useAuth from "../../../hooks/useAuth";
import ChangePhoneNumComponent from "../../../components/_dashboard/ChangePhoneNumComponent";
import ChangePWDForm from "../../../components/_dashboard/ChangePWDForm";
import { USER_TYPE } from "utils/dataCenter";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 88;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  height: isMobile ? APPBAR_MOBILE : APPBAR_DESKTOP,
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: "white",
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  borderBottom: "0.1px solid rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

const ChangeButton = styled(Button)(() => ({
  color: "#2137b3",
  fontSize: 12,
  "&:hover": {
    background: "#eeeeee",
  },
}));

const ContentContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  paddingLeft: 5,
  alignItems: "center",
}));

// ----------------------------------------------------------------------

type DashboardNavbarProps = {
  onOpenSidebar: VoidFunction;
};

export default function DashboardNavbar({
  onOpenSidebar,
}: DashboardNavbarProps) {
  const { headquarter } = useSelector((state: RootState) => state.auth);
  const { logout } = useAuth();
  const { isCollapse } = useCollapseDrawer();
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isChangePhone, setIsChangePhone] = useState(false);

  const dashboardName = headquarter.NAME;
  const dashboardName2 = "담당자님";
  const handleChangePhoneNumber = () => {
    if (isChangePhone) {
      setIsEditModalOpen(false);
      setIsChangePhone(false);
    } else {
      setIsChangePhone(true);
    }
  };

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` },
        }),
      }}
    >
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        <LogoAcc
          sx={
            isMobile
              ? { width: 75, height: 75 }
              : { width: 120, height: 120, marginLeft: 2 }
          }
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: 20,
            // marginBottom: 10,
            flexWrap: "wrap",
          }}
        >
          <p
            style={
              isMobile
                ? { marginRight: 5, fontSize: 18, color: "black" }
                : { fontSize: 30, color: "black" }
            }
          >
            안녕하세요,&nbsp;
          </p>
          <p
            style={
              isMobile
                ? { fontSize: 18, color: "#04B1FF", fontWeight: "bold" }
                : { fontSize: 30, color: "#04B1FF", fontWeight: "bold" }
            }
          >
            {dashboardName}&nbsp;
          </p>
          <p
            style={
              isMobile
                ? {
                    fontSize: 18,
                    marginRight: 10,
                    fontWeight: "bold",
                    color: "black",
                  }
                : {
                    fontSize: 30,
                    marginRight: 10,
                    fontWeight: "bold",
                    color: "black",
                  }
            }
          >
            {dashboardName2}
          </p>
        </div>
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <>
              <IconButton
                ref={ref}
                onClick={() => setIsOpen(true)}
                style={
                  isMobile
                    ? {
                        border: "1px solid rgba(0, 0, 0, 0.1)",
                        borderRadius: 8,
                        padding: 0,
                        paddingLeft: 6,
                        paddingRight: 6,
                      }
                    : {
                        border: "1px solid rgba(0, 0, 0, 0.1)",
                        borderRadius: 8,
                      }
                }
              >
                <img
                  src={logo}
                  width={isMobile ? "60" : "90"}
                  height="40"
                  alt="img"
                />
              </IconButton>

              {/* 변경 모달 창  */}
              <Menu
                open={isOpen}
                anchorEl={ref.current}
                onClose={() => setIsOpen(false)}
                PaperProps={{
                  sx: { maxWidth: 500 },
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <div style={{ padding: 20, paddingLeft: 30, paddingRight: 30 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      // paddingBottom: 15,
                    }}
                  >
                    <p
                      style={{
                        color: "#4D4C72",
                        fontWeight: 600,
                        fontSize: 20,
                        paddingRight: 150,
                      }}
                    >
                      {headquarter.NAME}
                    </p>
                    <Icon
                      icon={xLg}
                      width="20"
                      height="20"
                      onClick={() => setIsOpen(false)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>

                  <div
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: 30,
                    }}
                  >
                    <Button
                      style={{
                        color: "white",
                        background: "#3b41f7",
                        width: "100%",
                        padding: 10,
                      }}
                      onClick={async () => {
                        try {
                          await logout(true);
                        } catch (e) {
                          console.log("logout error : ", e);
                        }
                      }}
                    >
                      Logout
                    </Button>
                  </div>

                  {/* <p style={{ fontSize: 12, color: "#a0a0a0" }}>
                    ※ 서비스 이용 중지를 원하시면 아래 버튼을 통해 문의해주세요.
                  </p>
                  <div
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: 10,
                    }}
                  >
                    <Button
                      style={{
                        color: "#8d9297",
                        background: "#e5e9ec",
                        width: "100%",
                        padding: 10,
                      }}
                    >
                      서비스 이용 중지 요청
                    </Button>
                  </div> */}
                </div>
              </Menu>
            </>
          </span>
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
